import { Component, OnInit } from '@angular/core';
import { ZytdItem } from './zytd-item';
import { ZytdItemEntities } from './zytd-item-entity';
import {ZytdItemDetail} from '../zytd-item-detail/zytd-item-detail';
import {zytdDetailEntities} from '../zytd-item-detail/zytd-item-entity';

@Component({
  selector: 'app-zytd',
  templateUrl: './zytd.component.html',
  styleUrls: ['./zytd.component.css']
})
export class ZytdComponent implements OnInit {

  zytdItems = ZytdItemEntities;
  zytdGroups = ZytdItemEntities.length / 3;

  selectedZytdItem: ZytdItem;

  zytdItemDetails = zytdDetailEntities;
  selecttedAytdItemDetailEntity: ZytdItemDetail;

  onSelect(item: ZytdItem): void {
    if(this.selectedZytdItem && this.selectedZytdItem.id === item.id){
      this.selectedZytdItem = null;
    } else {
      this.selectedZytdItem = item;
      this.selecttedAytdItemDetailEntity = null;
      for ( var i = 0 ; i < this.zytdItemDetails.length ; i++ )
      {
        if (this.zytdItemDetails[i].id === item.id){
          this.selecttedAytdItemDetailEntity = this.zytdItemDetails[i]
          break;
        }
      }
    }
  }

  constructor() { }

  ngOnInit() {
  }

}
